module.exports = __webpack_public_path__ + "static/media/processometer-three.ecd48b21.png";